export default __webpack_public_path__ + "static/media/XEMP.e15fd5e7.jpg";